/*
 * @Author: chenyan
 * @Date: 2017-12-07 13:59:36
 * @Description:
 * @Last Modified by: wanghf
 * @Last Modified time: 2025-11-05 15:42:33
 */

// const index = () => import('views/index/index.vue') // 根页面
// const loginIndex = () => import('views/login/index.vue') // 主页
const loginIndex = resolve => require(['@/views/login/index.vue'], resolve)// 主页
const login = resolve => require(['@/views/login/login.vue'], resolve)// 登录、忘记密码
const register = resolve => require(['@/views/login/register.vue'], resolve)// 登记注册
const AccountCreate = resolve => require(['@/views/login/accountCreate.vue'], resolve)// 填写账户信息
const setNewPwd = resolve => require(['@/views/login/setNewPwd.vue'], resolve)// 首次设置密码
const forgetPwd = resolve => require(['@/views/login/forgetPwd.vue'], resolve)// 忘记密码
const resetPwd = resolve => require(['@/views/login/resetPwd.vue'], resolve)// 设置密码
const PPAuth = resolve => require(['@/views/ppAuthorization/index'], resolve)// 平台授权请求 - 已登陆
const authSelectRegion = resolve => require(['@/views/ppAuthorization/authSelectRegion'], resolve)// 平台授权请求 - 选择展业地区
const authLogin = resolve => require(['@/views/ppAuthorization/authLogin'], resolve)// 平台授权请求 - 登陆

export default [{
  path: '/loginIndex',
  component: loginIndex,
  children: [
    // 登录
    {
      name: 'Login',
      path: '/aq/login',
      alias: ['/aq/login.htm'],
      component: login
    },
    // 登记注册
    {
      name: 'Register',
      path: '/aq/register',
      alias: [
        '/aq/register.htm'
      ],
      component: register,
      meta: {
        loggedOut: true,
        autoLoginOut: true
      }
    },
    // 填写账户信息
    {
      name: 'AccountCreate',
      path: '/aq/account-create',
      alias: [
        '/aq/account-create.htm'
      ],
      component: AccountCreate
    },
    // 重置密码
    {
      name: 'SetNewPwd',
      path: '/aq/setNewPwd',
      alias: [
        '/aq/setNewPwd.htm'
      ],
      component: setNewPwd

    },
    // 忘记密码
    {
      name: 'ForgetPwd',
      path: '/aq/forgetPwd',
      alias: [
        '/aq/forgetPwd.htm'
      ],
      component: forgetPwd

    },
    // 设置新密码
    {
      name: 'ResetPwd',
      path: '/aq/resetPwd',
      alias: [
        '/aq/resetPwd.htm'
      ],
      component: resetPwd
    },
    // 请求平台授权 - 已登陆
    {
      name: 'PPAuthSelectRegion',
      path: '/aq/authSelectRegion',
      alias: [
        '/aq/authSelectRegion.htm'
      ],
      component: authSelectRegion
    },
    {
      name: 'PPAuth',
      path: '/aq/pp-auth',
      alias: [
        '/aq/pp-auth.htm'
      ],
      component: PPAuth
    },
    {
      name: 'AuthLogin',
      path: '/aq/authLogin',
      alias: [
        '/aq/authLogin.htm'
      ],
      component: authLogin
    }
  ]
}
]
